// extracted by mini-css-extract-plugin
export default {"main":"LandingPage_main__J5Q19","footer":"LandingPage_footer__Z1QVP"};